import Services from 'API/services';
import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { toast } from "react-toastify";
import OtpBox from './OtpBox';
import { forgotPassword, updatePassword } from "API/services/newServices";

const ForgotPassword = ({ show, onHide, userType }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [userData, setUserData] = useState({})
    const [showOtpBox, setShowOtpBox] = useState(false)

    const validateEmail = (email) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            setError('Email is required');
            return;
        }
        if (!validateEmail(email)) {
            setError('Please enter a valid email address');
            return;
        }
        const payload = {
            email: email,
        };

        try {
            let res;
            if (userType === "propertyUser") {
                res = await Services.auth.propertyUserForgotPasswordService(payload);
            } else {
                res = await Services.auth.rroomUserForgotPasswordService(payload);
            }
            if (res.data.status === false) {
                toast.error(res.data.message, {
                    autoClose: 1000,
                    pauseOnHover: true,
                    position: "top-right",
                });
            }
            if (res.status === 200 && res.data.status === true) {
                setUserData(res.data.data);
                onHide()
                setShowOtpBox(true)
                changePassword(res.data.data.id)
            }
        } catch (err) {
            console.error(err);
            // setError('Something went wrong. Please try again.');
        }
    };

    const changePassword = async (id) => {
        const body = {
            admin: userData.logintype == userType,
            id: id,
        };
        const res = await forgotPassword(body);
        if (res?.status) {
            toast.success(res.message, {
                autoClose: 1000,
                pauseOnHover: true,
                position: "top-right",
            });
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Forget Password</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="text"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                isInvalid={!!error && !validateEmail(email)}
                            />
                            {error && <span className="text-danger fs-12">{error}</span>}
                            {success && <span className="text-success fs-12">{success}</span>}
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
            <OtpBox show={showOtpBox} setShow={setShowOtpBox} user={userData} />
        </>
    );
};

export default ForgotPassword;
